import L from "leaflet";
import "leaflet/dist/leaflet.css";

const PIN_ICON_SVG = `<svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.2725 9.2721C13.2725 10.333 12.851 11.3504 12.1009 12.1005C11.3507 12.8507 10.3333 13.2721 9.27246 13.2721C8.2116 13.2721 7.19418 12.8507 6.44403 12.1005C5.69389 11.3504 5.27246 10.333 5.27246 9.2721C5.27246 8.21123 5.69389 7.19381 6.44403 6.44367C7.19418 5.69352 8.2116 5.27209 9.27246 5.27209C10.3333 5.27209 11.3507 5.69352 12.1009 6.44367C12.851 7.19381 13.2725 8.21123 13.2725 9.2721ZM11.2725 9.2721C11.2725 9.80253 11.0617 10.3112 10.6867 10.6863C10.3116 11.0614 9.80289 11.2721 9.27246 11.2721C8.74203 11.2721 8.23332 11.0614 7.85825 10.6863C7.48317 10.3112 7.27246 9.80253 7.27246 9.2721C7.27246 8.74166 7.48317 8.23295 7.85825 7.85788C8.23332 7.48281 8.74203 7.2721 9.27246 7.2721C9.80289 7.2721 10.3116 7.48281 10.6867 7.85788C11.0617 8.23295 11.2725 8.74166 11.2725 9.2721Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.79401 15.5181C1.50484 14.2907 0.608609 12.7085 0.218639 10.9717C-0.17133 9.23492 -0.0375212 7.42149 0.603146 5.76074C1.24381 4.1 2.36256 2.66653 3.81792 1.6416C5.27328 0.61668 6.99988 0.0463399 8.77938 0.00270542C10.5589 -0.040929 12.3114 0.444102 13.8152 1.39646C15.3191 2.34882 16.5067 3.72574 17.228 5.35309C17.9493 6.98044 18.1718 8.78514 17.8675 10.539C17.5631 12.2928 16.7455 13.917 15.518 15.2061L9.31201 21.7241L2.79401 15.5181ZM14.07 13.8271L9.24301 18.8971L4.17301 14.0701C3.17037 13.1154 2.47334 11.8849 2.17005 10.5341C1.86676 9.18326 1.97084 7.77285 2.46912 6.48119C2.9674 5.18953 3.8375 4.07462 4.96941 3.27746C6.10131 2.4803 7.44418 2.03668 8.8282 2.0027C10.2122 1.96871 11.5752 2.3459 12.7449 3.08655C13.9146 3.8272 14.8383 4.89806 15.3994 6.16371C15.9605 7.42936 16.1336 8.83297 15.897 10.197C15.6604 11.5611 15.0246 12.8244 14.07 13.8271Z" fill="white"/></svg>`;

const pinIcon = L.icon({
  iconUrl: "data:image/svg+xml," + encodeURIComponent(PIN_ICON_SVG),
  iconSize: [54, 66],
  iconAnchor: [27, 66],
});

export class ContactMaps {
  constructor() {
    this.map = document.querySelector(".sites-map__leaflet");
    if (!this.map) return;
    this.init();
    this.bindLivewire();
  }

  init() {
    const rect = this.map.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) {
      console.warn(
        "Le conteneur de la carte n'est pas visible, report de l'initialisation",
      );
      setTimeout(() => this.init(), 100);
      return;
    }

    let longitude = this.map.dataset.longitude;
    let latitude = this.map.dataset.latitude;

    this.leaflet = L.map(this.map, { zoomControl: false }).setView([latitude, longitude], 12);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}{r}.png', {
    }).addTo(this.leaflet);

    this.marker = L.marker([latitude, longitude], { icon: pinIcon }).addTo(this.leaflet);
  }

  bindLivewire() {
    if (window.Livewire?.on) {
      Livewire.on("site-changed", ({ lat, lng }) => {
        if (this.leaflet) this.leaflet.setView([lat, lng]);
        if (this.marker) this.marker.setLatLng([lat, lng]);
      });
    }
  }
}
